/** Výčet hodnot kurzoru pro formulářové komponenty */
export enum Cursor {
    initial = "initial",
    pointer = "pointer",
    default = "default",
}
